// src/core/utils/jFormat.ts
import moment from 'jalali-moment';
import { faNumToEnNum } from './decimalExtentions';

/**
 * Convert a Jalali date like "۱۴۰۴/۰۸/۰۴" to the standard UTC instant
 * that represents **00:00 of that day in Iran (UTC+03:30)**.
 *
 * Example:
 *   jFormat('۱۴۰۴/۰۸/۰۴') -> '2025-10-25T20:30:00Z'
 */
export const jFormat = (jDate?: string): string => {
    if (!jDate) return '';
    const cleaned = faNumToEnNum(jDate);

    // 1) Parse as Jalali (date only)
    const mJ = moment(cleaned, 'jYYYY/jMM/jDD', 'fa');
    if (!mJ.isValid()) return '';

    // 2) Convert to Gregorian date string (no TZ influence)
    const gDate = mJ.locale('en').format('YYYY-MM-DD');

    // 3) Create UTC midnight for that Gregorian date
    const utcMidnightGregorian = moment.utc(`${gDate}T00:00:00`);

    // 4) Tehran 00:00 equals UTC - 03:30
    const utcInstantForTehranMidnight = utcMidnightGregorian
        .subtract(3, 'hours')
        .subtract(30, 'minutes');

    return utcInstantForTehranMidnight.format('YYYY-MM-DD[T]HH:mm:ss[Z]');
};